import { Container } from "react-bootstrap";
import ButtonLink from "../components/button/button-link/ButtonLink";

function About() {
  return (
    <Container className="not-found">
      <img src="/assets/img/lost.jpg" alt="lost" />
      <div>
        <b>404</b>
        <br />
        <b>You seem lost in a place that should not exist</b>
        <br />
        <p>even the map refuses to name it</p>
      </div>
      <ButtonLink href="/" rel="noopener noreferrer">
        RETURN HOME
      </ButtonLink>
    </Container>
  );
}

export default About;
